import store from '@/store';
import logError from '@/utils/logError/logError';
import handleNavigation from '@/utils/navigationUtils';
import waitForStoreGetter from '@/utils/waitForStoreGetter/waitForStoreGetter';

export const PAYMENT_PLANS_PAGE_FEATURE = 'rollout.payments.payment_plans_page';
export const INITIAL_DATA_TIMEOUT = 10000;
const UNAUTHORISED_ROUTE = { name: 'userError', params: { errorType: 'unauthorised' } };
const PAYMENTS_DISABLED_ANGULAR_ROUTE = 'app.payments.disabled';

const lacksPaymentsModule = () => store.getters['BusinessStore/featureFlagsLoaded']
  && !store.getters['BusinessStore/hasFeature']('payments_module');

const canOpenPaymentPlansPage = () => store.getters['BusinessStore/hasFeature'](PAYMENT_PLANS_PAGE_FEATURE)
  && !!store.getters['BusinessStore/attributes'].scheduled_payments_eligible
  && store.getters['StaffStore/hasPermission']('can_view_payments');

const paymentPlansRouteGuard = async (_to, _from, next) => {
  await waitForStoreGetter(store, 'isInitialDataLoaded', INITIAL_DATA_TIMEOUT).catch(() => {});

  try {
    if (lacksPaymentsModule()) {
      next(false);
      handleNavigation({ route: PAYMENTS_DISABLED_ANGULAR_ROUTE });
      return;
    }
    if (canOpenPaymentPlansPage()) {
      next();
      return;
    }
    next(UNAUTHORISED_ROUTE);
  } catch (error) {
    logError('Failed to check access to the payment plans page', error);
    next(UNAUTHORISED_ROUTE);
  }
};

export default paymentPlansRouteGuard;
